import { render, staticRenderFns } from "./activitiesTypeManageList.vue?vue&type=template&id=6be7a80e&scoped=true"
import script from "./activitiesTypeManageList.vue?vue&type=script&lang=js"
export * from "./activitiesTypeManageList.vue?vue&type=script&lang=js"
import style0 from "./activitiesTypeManageList.vue?vue&type=style&index=0&id=6be7a80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be7a80e",
  null
  
)

export default component.exports